/**
 * Sidebar-engagement timers: fires `sidebar-open-N-min` analytics events at
 * 1/5/10/20 minutes and a `sidebar-close` event on teardown.
 *
 * Module-level singleton — `initializeGlobalSidebarTimers` is idempotent (the
 * first call wins for the lifetime of the page) and `clearGlobalSidebarTimers`
 * cancels the pending events and emits the close event. `instance.tsx` boots
 * the timers from `InstanceLayout` in the sidebar; the navigation layer clears
 * them on sidebar-close. The thresholds (1/5/10/20 min) match the dashboard
 * funnel; changing them invalidates that report.
 */

import { trackEvent } from 'util/analytics';
import type { Datastore } from 'util/datastore';

const ONE_MINUTE_MS = 60_000;
const FIVE_MINUTES_MS = 300_000;
const TEN_MINUTES_MS = 600_000;
const TWENTY_MINUTES_MS = 1_200_000;

let timersInitialized = false;
let timers: ReturnType<typeof setTimeout>[] = [];

export function initializeGlobalSidebarTimers(datastore: Datastore) {
    if (timersInitialized) {
        return;
    }
    timersInitialized = true;

    timers = [
        setTimeout(() => trackEvent(datastore, 'sidebar-open-1-min'), ONE_MINUTE_MS),
        setTimeout(() => trackEvent(datastore, 'sidebar-open-5-min'), FIVE_MINUTES_MS),
        setTimeout(() => trackEvent(datastore, 'sidebar-open-10-min'), TEN_MINUTES_MS),
        setTimeout(() => trackEvent(datastore, 'sidebar-open-20-min'), TWENTY_MINUTES_MS),
    ];
}

export function clearGlobalSidebarTimers(datastore: Datastore) {
    trackEvent(datastore, 'sidebar-close');
    timers.forEach(clearTimeout);
    timers = [];
    timersInitialized = false;
}
